export default __webpack_public_path__ + "static/media/StairLeft.256.2ff14f73.png";